import { NgModule } from '@angular/core';
import { ContactFormComponent } from './contact-form.component';

@NgModule({
  imports: [ContactFormComponent],
  exports: [ContactFormComponent]
})
export class ContactFormModule {}
